import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {routing} from '../cssd/cssd.routing';

@NgModule({
  imports: [
    CommonModule,
      routing
  ],
  declarations: []
})
export class CssdModule { }



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/cssd/cssd.module.ts